import { Layout, Space, Spin, Typography, message } from "antd";
import dayjs from "dayjs";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BrandLogo from "../components/common/BrandLogo";
import FeedBackForm from "../components/FeedBack/FeedBackForm";
import { useTranslation } from "react-i18next";
import { ROUTES } from "../constants/Route";
import APIService from "../Api/api.service";
import { LOGO_SVG_URL } from "../constants/common";

const { Title } = Typography;

const FEEDBACK_API_PATH = "FeedbackSurvey/Submit";

const FeedBack = () => {
  const { Content, Header } = Layout;
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [apiservice] = useState(() => new APIService());

  const onFinish = async (values) => {
    const formatDateForApi = (val) => {
      if (val == null || val === undefined) return null;
      return dayjs.isDayjs(val) ? val.format("YYYY-MM-DD") : val;
    };
    const payload = {
      c_FK_ClientID: 0,
      c_ClientName: "",
      c_OrderID: values.orderNumber ?? "",
      c_EmailId: values.email ?? "",
      c_Point_1: "How likely is it that you would recommend Provider1st to a friend or colleague?",
      c_Rating_1: String(values.recommendationRating ?? ""),
      c_Point_2: "How satisfied are you with status updates and responsiveness?",
      c_Rating_2: String(values.statusUpdatesRating ?? ""),
      c_Point_3: "How satisfied are you with request turnaround time (receipt to fulfillment)?",
      c_Rating_3: String(values.turnaroundTimeRating ?? ""),
      c_Point_4: "How confident are you that releases are handled compliantly (HIPAA, State rules, etc.)?",
      c_Rating_4: String(values.complianceRating ?? ""),
      c_Point_5: "How satisfied are you with the accuracy and completeness of records released?",
      c_Rating_5: String(values.accuracyRating ?? ""),
      c_Point_6: "Is there anything else you would like to share about your experience with Provider1st?",
      c_Rating_6: String(values.additionalComments ?? ""),
      c_Point_7: "Would you like a representative from Provider1st to contact you to discuss your feedback or experience with our service?",
      c_Rating_7: String(values.contactRepresentative),
      c_Suitable_FromDate: formatDateForApi(values.suitableDateFrom),
      c_Suitable_ToDate: formatDateForApi(values.suitableDateTo),
      c_Suitable_Time: values.suitableTime != null && values.suitableTime !== undefined ? String(values.suitableTime) : null,
      c_Created_By: 1
    };
    console.log("payload", payload);

    setLoading(true);
    try {
      const result = await apiservice.postRequest(FEEDBACK_API_PATH, payload);
      setLoading(false);

      const isErrorResponse =
        !result ||
        (Array.isArray(result) && result.length === 0) ||
        (typeof result === "object" && typeof result.status === "number");

      if (isErrorResponse) {
        message.error("Something went wrong.");
      } else {
        navigate(ROUTES.FEEDBACK_THANKS);
      }
    } catch {
      setLoading(false);
      message.error("Something went wrong.");
    }
  };

  return (
    <Layout className="bg-white">
      <Header className="welcome-footer bg-white">
        <img
          alt="Provider1st Logo"
          className="mt-4 mx-auto"
          src={window.location.origin + LOGO_SVG_URL}
        />
      </Header>
      <Spin spinning={loading} tip="Submitting...">
        <Content className="p-4 pb-0 md:p-6">
          <div className="container mx-auto px-1 md:px-6">
            <Space direction="vertical" className="welcome-block" size={0}>
              <Title level={4} className="text-black welcome-line">
                We'd love your feedback!
              </Title>
              <Title level={4} className="text-black welcome-sub-line">
                <Typography.Text>
                  Your voice and experience matters to us at Provider1st! Please
                  take this brief survey (2-5 minutes) so we can continue to
                  provide the best service possible.
                </Typography.Text>
              </Title>
            </Space>

            <div className="mt-4">
              <FeedBackForm
                onFinish={onFinish}
                loading={loading}
                languageKey={i18n.language}
              />
            </div>
          </div>
        </Content>
      </Spin>
    </Layout>
  );
};

export default FeedBack;
